export const GetIconMixin = {
  methods: {
    getPaymentServiceIcon(name) {
      switch (name) {
        case 'line':
        case 'linepay':
        case 'linepay-offline':  
          return require('@/assets/icons/linepay.png');
        case 'jko':
        case 'jko-offline':  
          return require('@/assets/icons/jko-pay.svg');
        case 'icashpay':
        case 'icashpay-offline':
          return require('@/assets/icons/icash-pay.svg');
        case 'easywallet':
          return require('@/assets/icons/easywallet.png');
        case 'tappay':
          return require('@/assets/icons/tappay.png');
        case 'apple':
          return require('@/assets/icons/apple-pay.svg');
        case 'google':
          return require('@/assets/icons/google-pay.svg');
        case 'direct':
        case 'credit':
          return require('@/assets/icons/credit-cards.png');
        case 'ipassmoney':
        case 'ipassmoney-offline':
        case 'twqr-ipassmoney':  
          return require('@/assets/icons/ipassmoney.png');
        case 'pxpayplus':
          return require('@/assets/icons/pxpayplus.png');
        case 'pluspay':
          return require('@/assets/icons/pluspay.png');  
        case 'twqr':
        case 'yuanta':
        case 'twqr-yuanta':
        case 'yuanta-offline':  
          return require('@/assets/icons/twqr.png');   
        case 'aftee':  
        case 'aftee-offline':  
        case 'aftee-aftee':  
          return require('@/assets/icons/aftee.png');      
        default:
          return null;
      }
    },
    getResolvedIcon(item) {
      // 因為TWQR的結構不太一樣，為區分不同的TWQR服務供應商
      if (item.service === 'twqr') {
        const key = item.service + '-' + item.type.split('-')[0]; // e.g., "twqrcredit"
        const icon = this.getPaymentServiceIcon(key);
        return icon || this.getPaymentServiceIcon('twqr'); // fallback
      }
      // 因為 DDPAY 訂單列表的回傳值不同，針對cardpay/tappay做轉換
      if (['tappay', 'cardpay'].includes(item.service)) {
        return this.getPaymentServiceIcon(item.type || item.service); // fallback
      }
      return this.getPaymentServiceIcon(item.service);
    }
  }
};